import React, {useCallback} from 'react'
import {ButtonLink, TrashBinIcon} from '@modifi/ui'

type DeleteBeneficialOwnerButtonProps = {
  onClick: () => void
  externalPersonId: string
}

const DeleteBeneficialOwnerButton: React.FC<DeleteBeneficialOwnerButtonProps> = ({
  onClick,
  externalPersonId,
}) => {
  const handleClick = useCallback(
    (e: React.UIEvent) => {
      e.preventDefault()
      onClick()
    },
    [onClick]
  )

  return (
    <ButtonLink
      onClick={handleClick}
      iconOnly
      transparent
      data-target="open-delete-beneficial-owner-dialog"
      data-external-id={externalPersonId}
    >
      <TrashBinIcon />
    </ButtonLink>
  )
}

export default DeleteBeneficialOwnerButton
